import { messageTypeEntityName } from '../../../backend/config/classifiers';
import { cardColors } from '@juvare/common-web-ui/Cards/cardColors';
import { ChipLight } from '@juvare/common-web-ui/ChipLight';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Chip, IconButton, Tooltip, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { AlertIcon } from '../../features/alerts/components/AlertIcon/AlertIcon';
import { useAlertUiTranslation } from '../../hooks';
export const AlertNotificationContentHeader = (props) => {
    const { t } = useAlertUiTranslation();
    const upSmScreen = useMediaQuery((theme) => theme.breakpoints.up('sm'));
    return (React.createElement(Box, { sx: [
            {
                display: 'grid',
                p: 2,
                rowGap: upSmScreen ? 2 : 0,
                columnGap: upSmScreen ? 2 : 0,
                gridTemplateColumns: upSmScreen ? 'auto 1fr auto' : '1fr auto',
                gridTemplateRows: upSmScreen ? '1fr' : 'auto 1fr',
            },
        ] },
        React.createElement(AlertViewIcon, { color: props.iconColor, icon: props.icon }),
        React.createElement(Box, { sx: [{ gridColumn: upSmScreen ? 2 : 1 }, !upSmScreen ? { gridRow: 2, gridColumnStart: 1, gridColumnEnd: 'span 2' } : null] },
            React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1, pt: { xs: 2, sm: 0 } } },
                React.createElement(Typography, { variant: 'h6', sx: { whiteSpace: 'pre-wrap', overflow: 'hidden', textOverflow: 'ellipsis' } }, props.title),
                props.phinBadgeLabel && React.createElement(ChipLight, { label: props.phinBadgeLabel, color: 'warning', size: 'small' })),
            React.createElement(Typography, { variant: 'caption' },
                React.createElement(NotificationMessageType, { messageType: props.notificationMessageType }),
                props.dateTimeText && props.dateTimeText,
                props.sender && spacer + t('common.byUser', { user: props.sender }),
                props.sharedOrNotText && spacer + props.sharedOrNotText),
            props.alertTemplateBadgeLabel && (React.createElement(Box, { sx: { pt: 1 } },
                React.createElement(Chip, { label: props.alertTemplateBadgeLabel, sx: { backgroundColor: themeColors.accent.grey.bold, color: themeColors.text.inverse }, size: 'small' })))),
        React.createElement(Box, { sx: { alignSelf: 'self-start', display: 'flex', gap: 1, color: 'primary.main' } }, props.actionsComponent)));
};
const AlertViewIcon = ({ color, icon }) => {
    return (React.createElement(Box, { sx: {
            alignSelf: 'self-start',
            width: 64,
            height: 64,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: color ? cardColors[color] : cardColors.grey,
            border: '1px solid ' + (color ? cardColors[color] : cardColors.grey),
            borderRadius: '50%',
        } },
        React.createElement(AlertIcon, { icon: icon, fontSize: 'large' })));
};
const NotificationMessageType = ({ messageType }) => {
    var _a, _b;
    const { data: messageTypeResult } = useStorageList(messageTypeEntityName, messageType
        ? {
            filter: [
                {
                    column: 'name',
                    op: '=',
                    value: messageType,
                },
            ],
        }
        : undefined);
    let messageTypeTooltip = messageType;
    if ((_b = (_a = messageTypeResult === null || messageTypeResult === void 0 ? void 0 : messageTypeResult.rows[0]) === null || _a === void 0 ? void 0 : _a.columns) === null || _b === void 0 ? void 0 : _b.alertInfo) {
        messageTypeTooltip = messageTypeResult.rows[0].columns.alertInfo;
    }
    return (React.createElement(React.Fragment, null,
        messageType,
        messageType && messageTypeTooltip && (React.createElement(React.Fragment, null,
            ' ',
            React.createElement(Tooltip, { title: messageTypeTooltip },
                React.createElement(IconButton, { size: 'medium', "data-test": 'tooltip-button', "aria-label": messageTypeTooltip, sx: { p: 0 } },
                    React.createElement(InfoOutlinedIcon, { color: 'primary', fontSize: 'small', sx: { verticalAlign: 'middle' } }))),
            spacer))));
};
const spacer = '  ●  ';
